import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Link from 'react-router/lib/Link';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../utils/analytics';
import {map} from 'lodash';

const Breadcrumbs = ({ breadcrumbs }) => (
  <div className="byline breadcrumbs">
    {
      map(breadcrumbs, ({ name, url, type }, i) => (
        <Breadcrumb key={name + i} type={type} name={name} url={url} index={i} />
      ))
    }
  </div>
);

Breadcrumbs.propTypes = {
  breadcrumbs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      type: PropTypes.string
    }).isRequired
  ).isRequired
};

export default Breadcrumbs;

export class Breadcrumb extends PureComponent {
  handleClick = ({ currentTarget: { innerHTML } }) => {
    sendAnalyticsEvent(
      'Breadcrumb',
      'Click',
      innerHTML
    );

    sendDataLayerEvent('Click', {
      linkType: 'Breadcrumb',
      linkTitle: this.props.name,
      linkHeadline: this.props.name,
      itemName: this.props.name,
      itemIndex: this.props.index,
      linkURL: this.props.url,
      // linkUID: '', not provided by the API
      pageModule: 'Byline'
    });
  };

  render() {
    return (
      <span key={this.props.url}>
        <span className="bullet">
          {this.props.index > 0 ? ' • ' : ''}
        </span>
        <Link
          to={this.props.url}
          rel={this.props.type === 'shopping' ? 'nofollow' : null}
          className="crumb"
          onClick={this.handleClick}
          dangerouslySetInnerHTML={{ __html: this.props.name }}
        />
      </span>
    );
  }
}

Breadcrumb.propTypes = {
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  type: PropTypes.string,
  index: PropTypes.number.isRequired
};
